module.exports = __webpack_public_path__ + "img/syringe.9e848f00.svg";